module.exports = __webpack_public_path__ + "img/x.78333498.png";